import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';

import {
  getCroppedAspectRatio,
  hasPhotoTransformFields,
  mapViewOptionsToTransform,
} from '@/entities/album';

const DEFAULT_PHOTO_ASPECT_RATIO = 4 / 3;
const VIDEO_ASPECT_RATIO = 16 / 9;

// Tiles get their width from the stored dimensions so the gallery lays out
// before any image bytes arrive and nothing jumps once they do.
export const getPhotoAspectRatio = (asset: Asset | undefined): number => {
  if (asset?.Kind.case !== 'Study') {
    return DEFAULT_PHOTO_ASPECT_RATIO;
  }

  const { Content: content, MedicalImageFeatures: features } = asset.Kind.value;

  if (content.case === 'DentalVideo') {
    return VIDEO_ASPECT_RATIO;
  }

  if (content.case !== 'DentalPhoto') {
    return DEFAULT_PHOTO_ASPECT_RATIO;
  }

  const metadata = content.value.Image?.Metadata;
  const imageMetadata = metadata?.case === 'Image' ? metadata.value : undefined;
  const width = Number(imageMetadata?.Width ?? 0);
  const height = Number(imageMetadata?.Height ?? 0);

  if (width <= 0 || height <= 0) {
    return DEFAULT_PHOTO_ASPECT_RATIO;
  }

  const imageAspectRatio = width / height;
  const viewOptions = features?.ViewOptionsV2;
  const cropBox =
    viewOptions && hasPhotoTransformFields(viewOptions)
      ? mapViewOptionsToTransform(viewOptions, imageAspectRatio).cropBox
      : null;

  return getCroppedAspectRatio(cropBox, imageAspectRatio);
};
